import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/lib/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/store/StoreProvider.tsx");
